// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"232":"70e5412e","285":"b50575c3","307":"089879dc","453":"874d65d5","802":"77603ad3"}[chunkId] + ".chunk.js";
};